// La ola de renovaciones: cuanta plata vence cada semana de las proximas seis.
//
// Es lo unico del panel que mira para adelante. Un plan dura 45 dias, asi que
// los clientes vencen en tandas: hay semanas de trece y semanas de sesenta y
// dos. Saber cual viene es lo que decide a quien hay que llamar, y cuando.
//
// Las barras son de plata, no de clientes: no es lo mismo que venzan diez
// Nutrivital que diez Fitfuel.

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { soles, numero, diaYMes } from './formato';
import { creceDesdeAbajo, levanta } from './motion';

export default function OlaRenovaciones({ semanas }) {
  if (!semanas || !semanas.length) {
    return null;
  }

  const mayor = Math.max(...semanas.map((s) => Number(s.monto)), 1);
  const total = semanas.reduce((a, s) => a + Number(s.monto), 0);
  const clientes = semanas.reduce((a, s) => a + Number(s.clientes), 0);
  const pico = semanas.reduce((a, s) => (Number(s.monto) > Number(a.monto) ? s : a), semanas[0]);

  return (
    <Card sx={{ p: 3, height: 1, display: 'flex', flexDirection: 'column', ...levanta }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2} sx={{ mb: .5 }}>
        <Box>
          <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Lo que vence en seis semanas</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {numero(clientes)} planes · {soles(total)} en juego
          </Typography>
        </Box>
        <Chip
          size="small"
          label={`Semana fuerte: ${diaYMes(pico.desde)}`}
          sx={{ fontWeight: 600, bgcolor: 'secondary.lighter', color: 'secondary.darker' }}
        />
      </Stack>

      <Box
        sx={{
          mt: 2.5, flex: 1, display: 'grid', gap: 1.25,
          gridTemplateColumns: `repeat(${semanas.length}, 1fr)`,
          alignItems: 'end', minHeight: 200,
        }}
      >
        {semanas.map((s, i) => {
          const alto = Math.max((Number(s.monto) / mayor) * 100, 6);
          const esPico = s.desde === pico.desde;
          return (
            <Tooltip
              key={s.desde}
              title={`${numero(s.clientes)} planes vencen entre el ${diaYMes(s.desde)} y el ${diaYMes(s.hasta)}`}
              arrow
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: .75, height: 1, justifyContent: 'flex-end' }}>
                <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: esPico ? 'primary.dark' : 'text.primary' }}>
                  {soles(s.monto)}
                </Typography>

                <Box
                  sx={{
                    width: '100%', maxWidth: 58, height: `${alto}%`, minHeight: 10,
                    borderRadius: '12px 12px 5px 5px',
                    background: (t) => esPico
                      ? `linear-gradient(180deg, ${t.palette.secondary.main}, ${t.palette.primary.main})`
                      : `linear-gradient(180deg, ${t.palette.secondary.light}, ${t.palette.secondary.main})`,
                    ...creceDesdeAbajo(i),
                    '&:hover': { filter: 'brightness(1.04)' },
                  }}
                />

                <Box sx={{ textAlign: 'center' }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.primary' }}>
                    {numero(s.clientes)}
                  </Typography>
                  <Typography sx={{ fontSize: 11, color: 'text.secondary', whiteSpace: 'nowrap' }}>
                    {i === 0 ? 'esta sem.' : diaYMes(s.desde)}
                  </Typography>
                </Box>
              </Box>
            </Tooltip>
          );
        })}
      </Box>
    </Card>
  );
}
